import React, { useEffect, useRef } from 'react';

const TermsAndConditions = () => {
  const contentRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
        }
      });
    }, observerOptions);

    if (contentRef.current) {
      observer.observe(contentRef.current);
    }

    return () => {
      if (contentRef.current) {
        observer.unobserve(contentRef.current);
      }
    };
  }, []);

  return (
    <section className="terms-section">
      <div className="terms-container">
        <h2 className="section-title">Terms and Conditions</h2>
        <div className="content-paragraph" ref={contentRef}>
          <p><strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          
          <h3 className="subsection-title">Acceptance of Terms</h3>
          <p>
            By accessing and using VAT Calculator, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
          </p>

          <h3 className="subsection-title">Use License</h3>
          <p>
            Permission is granted to temporarily use VAT Calculator for personal and commercial purposes. This is the grant of a license, not a transfer of title, and under this license you may not:
          </p>
          <ul className="terms-list">
            <li>Modify or copy the materials</li>
            <li>Use the materials for any commercial purpose without proper attribution</li>
            <li>Attempt to reverse engineer any software contained in the service</li>
            <li>Remove any copyright or other proprietary notations from the materials</li>
          </ul>

          <h3 className="subsection-title">Disclaimer</h3>
          <p>
            The VAT Calculator is provided "as is" without any warranties, expressed or implied. We make no representations or warranties regarding the accuracy, reliability, or suitability of the calculator for any particular purpose.
          </p>
          <p>
            While we strive to provide accurate VAT calculations, we cannot guarantee that the results are always correct. VAT rates may vary by jurisdiction and can change over time. Users are responsible for verifying calculations and ensuring compliance with applicable tax laws.
          </p>

          <h3 className="subsection-title">Limitation of Liability</h3>
          <p>
            In no event shall VAT Calculator or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the calculator, even if we have been notified orally or in writing of the possibility of such damage.
          </p>

          <h3 className="subsection-title">Accuracy of Information</h3>
          <p>
            We endeavor to keep VAT rates and currency information up to date, but we do not warrant that the information is complete, accurate, or current. Tax laws and rates change frequently, and users should verify all calculations with their local tax authorities or professional advisors.
          </p>

          <h3 className="subsection-title">User Responsibilities</h3>
          <p>
            Users are responsible for ensuring that their use of the calculator complies with all applicable laws and regulations. The calculator is a tool to assist with calculations and should not be considered as professional tax advice.
          </p>

          <h3 className="subsection-title">Intellectual Property</h3>
          <p>
            All content, features, and functionality of the VAT Calculator, including but not limited to text, graphics, logos, and software, are the property of VAT Calculator and are protected by international copyright, trademark, and other intellectual property laws.
          </p>

          <h3 className="subsection-title">Modifications</h3>
          <p>
            We reserve the right to modify or discontinue the service at any time without prior notice. We may also revise these terms of service at any time without notice. By continuing to use the service after such modifications, you agree to be bound by the revised terms.
          </p>

          <h3 className="subsection-title">Governing Law</h3>
          <p>
            These terms and conditions are governed by and construed in accordance with applicable laws. Any disputes relating to these terms shall be subject to the exclusive jurisdiction of the courts in the applicable jurisdiction.
          </p>

          <h3 className="subsection-title">Contact Information</h3>
          <p>
            If you have any questions about these Terms and Conditions, please contact us through our Contact Us page.
          </p>
        </div>
      </div>
    </section>
  );
};

export default TermsAndConditions;
